module.exports = __webpack_public_path__ + "static/vf_mpullover_core.51f38bcd.svg";